module.exports = __webpack_public_path__ + "static/media/purchase-tag.6e985472.svg";